import { Burger, Center, Flex, Group, Image, Stack } from '@mantine/core';
import { IconChevronLeft as LeftIcon, IconChevronRight as RightIcon } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './Sidebar.module.css';
import logoSrc from './assets/logo.png';
import { SidebarItem, useSidebarItems, useSidebarState } from './hooks/useSidebar';

interface SidebarProps {
  toggleMenu: () => void;
  opened: boolean;
  items: SidebarItem[];

  header?: ReactNode;
}

export function Sidebar({ toggleMenu, opened, items, header }: SidebarProps) {
  const { isMainActive, toggleMainActive } = useSidebarState();
  const links = useSidebarItems({ items, isCollapsed: !isMainActive, baseUrl: null });
  const { t } = useTranslation();
  return (
    <nav
      className={classes.navbar}
      aria-label={t('sidebar.navigation')}
    >
      <Flex
        justify="space-between"
        direction="column"
        data-collapsed={!isMainActive}
        className={classes.navbarMain}
      >
        <div
          role="button"
          tabIndex={0}
          aria-label={t('sidebar.toggleMain')}
          aria-expanded={isMainActive}
          onClick={toggleMainActive}
          onKeyDown={event => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              toggleMainActive();
            }
          }}
          data-collapsed={!isMainActive}
          className={classes.sidebarToggle}
        >
          {isMainActive ? <LeftIcon /> : <RightIcon />}
        </div>
        <Stack style={{ overflowY: 'auto' }}>
          <Group
            className={classes.header}
            justify="space-between"
            align="center"
            ta="center"
          >
            <Center
              mt="15x"
              flex={1}
              h="30%"
            >
              <Image
                h={isMainActive ? '70px' : '30px'}
                fit="contain"
                src={logoSrc}
              />
            </Center>
            <Burger
              opened={opened}
              onClick={toggleMenu}
              hiddenFrom="sm"
              size="sm"
            />
          </Group>
          {header}
          {links}
        </Stack>
      </Flex>
      <div
        id="context-sidebar"
        data-collapsed={isMainActive}
        className={classes.contextSidebar}
      />
    </nav>
  );
}
